/**
 * The enumeration defines possible targets for DeleteResources activity.
 *
 * @see https://github.com/Microsoft/MIMWAL/blob/master/src/WorkflowActivityLibrary/Enumerations/DeleteResourcesTargetType.cs
 */
export enum DeleteResourcesTargetType {
  /**
   * The target for DeleteResources activity is the target of the request
   */
  WorkflowTarget,

  /**
   * The target for DeleteResources activity is specified search query
   */
  SearchForTarget,

  /**
   * Resolve the reference as the target for the DeleteResources activity
   */
  ResolveTarget,
}
